import { InModalViewKey } from "~/injectionKeys";

/**
 * Force clean the history stack of nuxt-page-plus modal router by removing the background view and id from state.
 * This is useful in some case to prevent buggy behaviour
 * @returns void
 */
function forceCleanNuxtPagePlusModalHistoryStack() {
  history.state.backgroundView = undefined;
  history.state.id = undefined;
}

export function useModalRouterUtils() {
  const inModalView = inject(InModalViewKey, false);
  const modalRouter = useModalRouter();

  /**
   * A click callback utility for link who can be inside a modal router view, and go outside of it.
   * @param e The Click event
   * @param forceInModalComment allways consider the link is in a modalView
   * @returns true if utility cleaned the backgroundView, false otherwise
   */
  const onClickLinkCanGoOutsideModal = (
    e: MouseEvent | TouchEvent | KeyboardEvent,
    forceInModalComment: boolean | undefined = false,
  ): boolean => {
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) {
      return false;
    }
    if (inModalView || forceInModalComment) {
      forceCleanNuxtPagePlusModalHistoryStack();
      return true;
    }
    return false;
  };

  return {
    inModalView,
    forceCleanNuxtPagePlusModalHistoryStack,
    onClickLinkCanGoOutsideModal,
    modalRouter,
  };
}
